angular.module('rightPaneModule')
  .controller('DistrictCustomersUsageController', ['$scope', 'schoolApi', '$state', 'tableColumns', 'tableSort', 'timeframe', '$filter', 'navigation',
    function($scope, $schoolApi, $state, $tableColumns, $tableSort, $timeframe, $filter, $navigation) {

    $scope.listTableColumns = $tableColumns.getColumns('schoolsCustomerUsage');
    $scope.activeMetric = $state.params.sort || $scope.listTableColumns[0];
    $scope.years = { list: null, selected: {} };
    $scope.hasCustomerUsageError = false;

    $scope.timeframes = {
      list: [
        { id: '7d', name: 'Last 7 Days', by: 'day', active: true },
        { id: '30d', name: 'Last 30 Days', by: 'week', active: false }
      ],
      selected: {}
    };

    var updateUsage = function() {
      $scope.districtCustomersUsageReportingUrl = $schoolApi.getDistrictCustomersUsageExportUrl();

      // clear any previous data/dates from display and show spinner while fetching new data
      $scope.listTableData = undefined;

      //clear any previous errors off the scope
      $scope.hasCustomerUsageError = false;

      $schoolApi.getDistrictCustomersUsage().then(
        function(data) {
          if (!data.list || data.list.length < 1) {
            $scope.hasCustomerUsageError = true;
            return;
          }

          $scope.listTableData = $tableSort.sortColumn($scope.listTableColumns, data.list);

          //apply filters to total row
          data.totals.percent_total_customers = $filter('percent')(data.totals.percent_total_customers);
          data.totals.total_customers = $filter('number')(data.totals.total_customers);
          data.totals.total_sessions = $filter('number')(data.totals.total_sessions);

          //set totals array, the first element is the empty status column so no display
          $scope.usageTotals = ['', 'All Educators'].concat(_.values(data.totals));
        },
        function() {
          $scope.hasCustomerUsageError = true;
      });
    };

    var updateTableSort = function() {
      if ($scope.listTableData) {
        $scope.listTableData = $tableSort.sortColumn($scope.listTableColumns, $scope.listTableData);
      }
    };

    var updateData = function() {
      updateUsage();
    };

    var initializeData = function(e, item) {
      $scope.item = item;

      $scope.$on('updateSortableTable', updateTableSort);

      $scope.$on('listTableRowClicked', function(e, item) {
        $navigation.handleRoute(e, item, {pane: 'school_customers_usage'});
      });
    };

    $scope.$on('yearSelected', updateData);

    $scope.$on('timeframeSelected', updateData);

    $scope.$on('updateYears', function(e, years) {
      $scope.years.list = angular.copy(years);
    });

    $scope.$on('itemReady', initializeData);
        updateUsage();
  }]);
